/** basic.installPoint */
export default {
    pointName: "Название точки",
    pointNamePla: "Введите название точки",
    deviceCoding: "Код устройства",
    deviceCodingPla: "Введите полный код устройства для поиска",
    pointAddrPla: "Введите адрес точки для поиска",
    installNews: "Информация об установке точки",
    saveEdit: "Сохранить изменения",
    verifyEdit: "Подтвердить изменения",
    collectPointTips: "Добавить точку в избранное?",
    colloect: "Избранное",
    drawerTitle: "Детали точки установки",
    dialog: "Новая точка установки",
    rules_noSpecial: "Нельзя использовать специальные символы!",

    form_deviceNum: "Код устройства:",
    form_deviceNumPla: "Введите код устройства",
    form_floorNum: "Количество этажей:",
    form_floorNumPla: "Введите количество этажей",
    form_pointAddrPla: "Введите адрес точки",
    form_entity: "Организация:",
    form_pointAddr: "Адрес точки:",
    form_siteName: "Название объекта",
    form_PointName: "Название точки:",
    form_entityPla: "Выберите организацию",
    form_naem: "Название",

    message_succ: "Точка добавлена в избранное!",
    message_lose: "Не удалось добавить точку в избранное!",
    delUnit: "Удалить эту организацию?",

    img_title: "Изображения точки установки",
    img_deleteTips: "Удалить это изображение?",
    img_messageSucc: "Изображение загружено!",
    img_messageLose: "Не удалось загрузить изображение!",
    img_messageCancel: "Загрузка отменена",
    img_tips: "Сначала подтвердите или отмените текущую точку!",
    img_pointSucc: "Точка сохранена!",
    img_pointLose: "Не удалось сохранить точку!",
    point_delete_tips:
        "Удаление точки отвяжет связанные устройства, а изображения и данные точки будут удалены. Удалить точку?",
}

